// extracted by mini-css-extract-plugin
module.exports = {"main":"Universal_main__r3KYh","headerBox":"Universal_headerBox__u49RH","seeAll":"Universal_seeAll__JjP2u","header":"Universal_header__G_FuV","Link":"Universal_Link__3SEB7"};